import { Button, Image, Link, Text, VStack } from '@direct-frontend/components';
import { CompanyLogo } from '#shared/components/CompanyLogo';
import { openMessenger } from '#shared/lib/messenger';
import { useThemeColor } from '#shared/lib/theme';
import { Modal } from '#shared/ui/Modal';
import liteWelcomeBodySrc from './assets/liteWelcomeBody.png';
import { type WelcomeModalViewProps } from './types';
import styles from './WelcomeModal.module.css';

export function LiteWelcomeModal({
    isOpen,
    onClose,
    onClick,
    'data-testid': dataTestId = 'WelcomeModal',
}: WelcomeModalViewProps) {
    const themeColor = useThemeColor();

    return (
        <Modal data-testid={dataTestId} withoutPaddings className={styles.modal} isOpen={isOpen} onClose={onClose}>
            <VStack alignItems="center" gap="28">
                <VStack alignItems="center" gap="28">
                    <CompanyLogo alt="Логотип" width={328} height={60} theme={themeColor} />
                    <Image alt="Этапы подключения KIT Lite" width="100%" height="auto" src={liteWelcomeBodySrc} />
                </VStack>
                <VStack alignItems="stretch" gap="16" width="max">
                    <Text textAlign="center" role="supplementary">
                        Управляйте контентом, ценами, заказами и клиентами
                    </Text>
                    <Button
                        size="l"
                        color="accent"
                        width="max"
                        onClick={onClick}
                        data-testid={`${dataTestId}.StartButton`}
                    >
                        Поехали!
                    </Button>
                    <Text textAlign="center" role="supplementary">
                        Чтобы легко перейти к созданию сайта на Яндекс КИТ,{' '}
                        <Link
                            data-testid={`${dataTestId}.SupportLink`}
                            onClick={() => {
                                onClose();
                                openMessenger();
                            }}
                        >
                            напишите в поддержку
                        </Link>
                    </Text>
                </VStack>
            </VStack>
        </Modal>
    );
}
